import { ResourceType } from '../../shared/resource-type';

/**
 * The resource type for Section
 *
 * Needs to be in a separate file to prevent circular
 * dependencies in webpack.
 */

export const SECTION = new ResourceType('section');
